var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactUs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18.518
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#339dff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1362b1"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Search results for Call us - Flaticon-2"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280028",
  d: "M24.512 38.02H36.42l-7.073 4.849-4.811-3.3a2.119 2.119 0 0 0-.024-1.549ZM21.4 40.834l1.736-1.057a1.112 1.112 0 0 0 .385-1.505l-1.567-2.714a1.111 1.111 0 0 0-1.593-.36L17.5 37.166c-1.36 4.793 4.753 15.169 9.441 16.352l3.133-1.491a1.111 1.111 0 0 0 .485-1.559l-1.567-2.714a1.112 1.112 0 0 0-1.5-.42l-1.783.975a16.988 16.988 0 0 1-4.309-7.475Zm15.887-2.191-7.657 5.248a.5.5 0 0 1-.576-.007L23.973 40.4a2.116 2.116 0 0 1-.316.236l-1.1.668a17.28 17.28 0 0 0 3.328 5.763l1.128-.617a2.119 2.119 0 0 1 2.849.8l.972 1.683H36.5a.815.815 0 0 0 .813-.813v-9.288a.807.807 0 0 0-.022-.189Z",
  fillRule: "evenodd",
  fill: "url(#a)",
  transform: "translate(-17.308 -35)"
}))));
export default SvgContactUs;